// Generated by scripts/generate-public-surface.ts. Do not edit.

import type { CountryValidator } from "../../types";

import { createValidator } from "#stdnum-runtime";

const iva: CountryValidator<"IT"> = createValidator(
  "it.iva",
  106,
);

export default iva;
export const compact = iva.compact;
export const format = iva.format;
export const validate = iva.validate;
export const generate = (): string =>
  iva.generate?.() ??
  (() => {
    throw new Error(
      "Validator it.iva cannot generate values",
    );
  })();
